export default "__VITE_ASSET__DX$Z4s8e__"